import { createContext, Dispatch, ReactNode, SetStateAction, useCallback, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { PagesPaginateModel } from "../../../models/Paginate/PagesPaginate";
import { AgentsTermsService } from "../../../services/Agents/Terms/AgentesTermsService";
import { AgentsTermsModel } from "../../../models/Agents/Terms/AgentsTermsModel";

interface ContextProps {
    terms: AgentsTermsModel[],
    params: any,
    setParams: Dispatch<SetStateAction<any>>,
    pages: PagesPaginateModel,
    setPages: Dispatch<SetStateAction<PagesPaginateModel>>,
    isLoading: boolean,
    error: string,
    setError: Dispatch<SetStateAction<string>>,
    handleListTerms: (params?: any) => void,
    handleDelete: (id: number) => Promise<boolean>,
}

export const AgentsTermsContext = createContext<ContextProps>({} as ContextProps);

interface AgentsTermsProviderProps {
    children: ReactNode;
}

export const AgentsTermsProvider = ({ children }: AgentsTermsProviderProps) => {
    const [params, setParams] = useState<any>({ withPaginate: false });
    const [pages, setPages] = useState<PagesPaginateModel>({});
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [terms, setTerms] = useState<AgentsTermsModel[]>([])

    const service = new AgentsTermsService();

    const handleListTerms = useCallback(async (categoryId?: any) => {
        try {
            setIsLoading(true);
            const [_Response, _Error] = await service.list({filter: {category_id: categoryId}, withPaginate: false});
            setIsLoading(false);

            if (!!_Error) {
                return setError(_Response?.message || _Error);
            }

            setTerms(_Response?.items);
            return setError('');
        } catch (e) {
            setIsLoading(false);
            setTerms([]);
            setError('Não foi possível carregar os termos.');
        }
    }, []);

    const handleDelete = async (id: number) => {
        try {
            setIsLoading(true);
            const [_Response, _Error] = await service.delete(id);
            setIsLoading(false);

            if (!!_Error) {
                setError(_Response?.message || _Error);
                return false;
            }

            setError('');
            return true;
        } catch (e: any) {
            setIsLoading(false);
            setError(e.response?.data?.message || 'Houve um erro ao deletar a categoria');
            return false;
        }
    }

    useEffect(() => {
        if (error) {
            toast.error(error);
            setError('');
        }
    }, [error]);

    return (
        <AgentsTermsContext.Provider value={{
            terms,
            params,
            setParams,
            pages,
            setPages,
            isLoading,
            error,
            setError,
            handleListTerms,
            handleDelete
        }}>
            {children}
        </AgentsTermsContext.Provider>
    );
}

export const useAgentsTerms = () => useContext(AgentsTermsContext);